var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 9.93198 15.9043 11.608 14.3003 12.4406C15.6434 12.9598 16.8044 13.8814 17.6996 14.8961C19.058 16.4359 20 18.4121 20 20L19 21H5L4 20C4 18.4121 4.94197 16.4359 6.30036 14.8961C7.19555 13.8814 8.35657 12.9598 9.69967 12.4406C8.09575 11.608 7 9.93198 7 8ZM9.00052 7.94379C9.00017 7.96249 9 7.98122 9 8C9 9.65685 10.3432 11 12 11C13.6568 11 15 9.65685 15 8C15 6.34315 13.6568 5 12 5C11.7859 5 11.577 5.02244 11.3755 5.06509L11.9552 7.10345L9.00052 7.94379ZM17.8249 19C17.5637 18.1562 17.0137 17.1417 16.1999 16.2192C15.0407 14.9053 13.5416 14 12 14C10.4584 14 8.9593 14.9053 7.80014 16.2192C6.98632 17.1417 6.43633 18.1562 6.17507 19H17.8249Z'
      })
    ),
    props
  );
}

module.exports = Icon;
